<template>
  <section class="reports traccar_wrp">
    <div v-if="popupShow" class="popup-overlay">
      <div class="popup-container">
        <div class="popup-content">
          <div id="details" class="overlay waste_type_pop">
            <div class="overlay_inner">
              <div class="row form-modal popup_modal rounded">
                <div class="iconMina">
                  <i class="fa fa-exclamation-triangle" style="font-size: 48px; color: white"></i>
                </div>
                <h3 class="popup-titles">Warning!</h3>
                <p class="popup-message">There is no trip associated.</p>

                <div class="form-actions dismiss">
                  <button class="popup-dismiss" @click="onModalClose">Close</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="lineStatusPopUP" class="">
      <div class="overlay">
        <div class="overlay_inner">
          <div class="form-modal">
            <h4>Update Line Status</h4>
            <div class="form-actions">
              <button v-bind:class="'mr-2 btn gradientbt'" @click="selectAll()">
                Mark All
              </button>
              <vue-form :state="formstate" class="formadd_scroll">
                <div class="houses_wrp">
                  <div class="flex house_number_wrp" v-for="(item, Index) in filteredLineStatusArray" :key="item">
                    <div class="house_number_boxs">
                      <h5>Line Number {{ item.lineNumber }}</h5>
                    </div>
                    <input type="checkbox" v-model="item.status" @change="onCheckboxChange(item)"
                      style="margin-left: 10px" />
                  </div>
                </div>
              </vue-form>
              <button v-bind:class="'mr-5  btn btn-default'" @click="onClose()">
                Cancel
              </button>
              <button v-bind:class="'mr-2 btn gradientbt'" @click="updateLineStatus">
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="loadings" class="overlay">
      <div class="content content-centered">
        <pulse-loader></pulse-loader>
        <p>Please Wait...</p>
      </div>
    </div>

    <div class="monitoring_wrp">
      <div class="col-md-12 city_dropdown">
        <div></div>
        <button v-if="this.$store.state.auth.user.role.key === 'superAdmin' ||
          this.$store.state.auth.user.role.key === 'cityAdmin' ||
          this.$store.state.auth.user.role.key === 'subCityAdmin'
          " :disabled="selectedRow.percentages == 100" class="btn gradientbt mark" @click="falseStatusLineList">
          Mark Line complete
        </button>
        <button class="btn gradientbt" @click="refreshReportList">Refresh</button>
      </div>

      <div class="col-sm-12" style="padding: 0px">
        <div class="col-md-3">
          <div class="dates_left_wrp">
            <div class="dates_left new_dates_left">
              <label>Zone</label>
              <date-picker id="startDate" @input="startDate" v-model="date" lang="en" name="startDate"
                :not-after="disabledStartDate" :clearable="false" required input-class="form-control" width="100%"
                valueType="format" :format="'DD-MM-YYYY'" placeholder="Date Filter"></date-picker>
            </div>
            <div class="scroll-items row">
              <div class="details-card" style="background: #fff">
                <div class="collection_divisions_table zoneDetails">
                  <table>
                    <tr>
                      <th>Zone</th>
                      <th>Percentage</th>
                    </tr>
                    <tr v-for="(item, index) in datas" :key="index" @click="onRowClick(item)"
                      :class="{ 'selected-row': selectedRow === item }">
                      <td>
                        {{ item.areaName }}
                      </td>
                      <td>
                        <progress max="100" :value="item.percentages" class="progressContainer"></progress>
                        <p class="progressReference">{{ item.percentages }} %</p>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 media_padding">
          <div class="map-view">
            <traccarMonitoringMapBeta :key="refreshKey" />
          </div>
        </div>

        <div class="col-md-3 col-sm-12">
          <div class="trip_details route_tracking_trip_details">
            <div class="shedule_date_data">
              <label>Trip Details </label>
              <div class="zone_cart_wrp">
                <div class="shedule_date_inner">
                  <h5>Zone</h5>
                  <p>{{ details.zoneName ? details.zoneName : "--" }}</p>
                </div>
                <div class="shedule_date_inner">
                  <h5>Vehicle No</h5>
                  <p>{{ details.vehicleId ? details.vehicleId.vNumber : "--" }}</p>
                </div>
                <div class="shedule_date_inner">
                  <h5>Device Status</h5>
                  <p>{{ deviceStatus != undefined ? deviceStatus.status : "--" }}</p>
                </div>
                <div class="shedule_date_inner">
                  <h5>Trip Status</h5>
                  <p :class="details.tripStatus">
                    {{ details.tripStatus ? details.tripStatus : "--" }}
                  </p>
                </div>
                <div class="shedule_date_inner">
                  <h5>Trip Schedule</h5>
                  <p>{{ details.scheduleTime ? details.scheduleTime : "--" }}</p>
                </div>
              </div>
              <div class="zone_cart_wrp">
                <div class="shedule_date_inner">
                  <h5>Trip Start Time</h5>
                  <p>{{ details.startTime ? details.startTime : "--" }}</p>
                </div>
                <div class="shedule_date_inner">
                  <h5>Trip End Time</h5>
                  <p>{{ details.endTime ? details.endTime : "--" }}</p>
                </div>
              </div>
              <div class="zone_cart_wrp driver_zone_wrp">
                <div class="shedule_date_inner">
                  <h5>Driver Name</h5>
                  <p>
                    {{
                      details.driverFirstName
                      ? details.driverFirstName + " " + details.driverLastName
                      : "--"
                    }}
                  </p>
                </div>
                <div class="shedule_date_inner">
                  <h5>Driver Contact Number</h5>
                  <p>
                    {{ details.driverContactName ? details.driverContactName : "--" }}
                  </p>
                </div>
                <div class="shedule_date_inner">
                  <h5>Helper Name</h5>
                  <p>
                    {{
                      details.helperFirstName
                      ? details.helperFirstName + " " + details.helperLastName
                      : "--"
                    }}
                  </p>
                </div>
                <div class="shedule_date_inner">
                  <h5>Helper Contact Number</h5>
                  <p>
                    {{ details.helperContactName ? details.helperContactName : "--" }}
                  </p>
                </div>
                <div class="shedule_date_inner">
                  <h5>Total Lines</h5>
                  <p>{{ details.totalLines != null ? details.totalLines : "--" }}</p>
                </div>
                <div class="shedule_date_inner">
                  <h5>Completed Lines</h5>
                  <p>
                    {{ details.completedLines != null ? details.completedLines : "--" }}
                  </p>
                </div>
                <div class="shedule_date_inner">
                  <h5>Skipped Lines</h5>
                  <p>
                    {{
                      details.totalLines != null
                      ? details.totalLines - details.completedLines
                      : "--"
                    }}
                  </p>
                </div>
                <div class="shedule_date_inner">
                  <h5>Total Covered Distance [In Zone]</h5>
                  <p>
                    {{
                      details.tracarrDistInZone != null ? details.tracarrDistInZone : "--"
                    }}
                  </p>
                </div>
                <div class="shedule_date_inner">
                  <h5>Total Covered Distance</h5>
                  <p>
                    {{ details.tracarrDistance != null ? details.tracarrDistance : "--" }}
                  </p>
                </div>
                <div class="shedule_date_inner">
                  <h5>Total Time(Hrs)</h5>

                  <p>{{ details.totalTimes != null ? details.totalTimes : "--" }}</p>
                </div>
                <div class="shedule_date_inner">
                  <h5>Total Time [In Zone]</h5>
                  <p>
                    {{
                      details.TracarrTimeInZone != null ? details.TracarrTimeInZone : "--"
                    }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import traccarMonitoringMapBeta from "../gmapLocation/traccarMonitoringGMapBeta.vue";
import { eventBus, dutyTrackingService } from "../../../services";
import dateFormatter from "../../utilities/dateFormate";
import config from "../../../config";
import { date } from "faker/lib/locales/en";

export default {
  name: "traccarMonitoringBeta",
  components: {
    traccarMonitoringMapBeta,
  },
  data() {
    return {
      formstate: {},
      lineStatusPopUP: false,
      isChecked: false,
      selectedValues: [],
      requestData: {
        tripId: null,
        lineNumbers: [],
      },
      popupShow: false,
      selectedRowId: null,
      selectedRow: null,
      percentages: {},
      loadings: false,
      liveLocationData: {},
      disabledStartDate: new Date(),
      refreshKey: 0,
      liveData: [],
      traccarId: null,
      cityList: [],
      traccarUrl: {},
      socket: null,
      details: {},
      datas: [],
      sliderValue: 50,
      startDateIso: this.getFormattedDate(new Date()),
      date: new Date().toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      }),
      loading: false,
      cityAdmin: false,
      driverList: [],
      surveyorList: [],
      traccarMonitoringZoneTable: null,
      parameters: {},
      city: {},
      staffLocationRefresh: null,
      staffLocationRefreshs: null,
      columns: ["areaName", "percentage"],
      startTime: null,
      endTime: null,
      refreshId: null,
      LivePositions: [],
      deviceStatus: {},
      selectedId: null,
    };
  },
  methods: {
    selectAll() {
      this.filteredLineStatusArray.forEach((item) => {
        item.status = true;
        this.selectedValues.push(item.lineNumber);
      });
      if (this.refreshId) {
        this.getOnZoneDetailsList(this.refreshId);
      } else {
        this.getOnZoneDetailsList(this.selectedId);
      }
    },

    updateLineStatus() {
      if (this.refreshId) {
        this.selectedId = null;
        this.requestData = {
          tripId: this.refreshId,
          lineNumbers: this.selectedValues,
        };
      } else {
        this.requestData = {
          tripId: this.selectedId,
          lineNumbers: this.selectedValues,
        };
      }
      //   console.log("updateLineStatus >>>>", this.selectedRow);
      //   this.requestData = {
      //     tripId: this.refreshId,
      //     lineNumbers: this.selectedValues,
      //   };
      this.lineStatusPopUP = false;
      this.selectedValues = [];
      return dutyTrackingService
        .updateCollectedLinesStatus(this.requestData)
        .then((response) => {
          this.getTraccarMonitoring();
        })
        .catch((error) => {
          this.loading = false;
          console.error("tracking.updatelinestatus-error:", error);
        });
    },
    onCheckboxChange(data) {
      
      if (data.status) {
        this.selectedValues.push(data.lineNumber);
      } else {
        const index = this.selectedValues.indexOf(data.lineNumber);
        if (index !== -1) {
          this.selectedValues.splice(index, 1);
        }
      }
      this.selectedValues = Array.from(this.selectedValues);
    },
    falseStatusLineList() {
      this.lineStatusPopUP = true;
      this.filteredLineStatusArray = this.details.routeFileGeoLoc.reduce(
        (result, item) => {
          const hasSameLineNumber = result.some(
            (filteredItem) => filteredItem.lineNumber === item.lineNumber
          );

          if (item.status === false && !hasSameLineNumber) {
            result.push({ lineNumber: item.lineNumber, status: item.status });
          }
          return result;
        },
        []
      );
    },
    onClose() {
      this.lineStatusPopUP = false;
    },
    getTraccarMonitoring() {
      this.parameters.date = this.startDateIso;
      if (this.parameters.cityId != undefined) {
        return dutyTrackingService
          .traccarMonitoring(this.parameters)
          .then((res) => {
            const newDataArray = [];
            res.data.forEach((el) => {
              const modifiedData = { ...el };
              modifiedData["percentages"] =
                el.completedLines != null &&
                  el.totalLines > 0 &&
                  el.completedLines > 0 &&
                  el.totalLines != null
                  ? Math.ceil((el.completedLines / el.totalLines) * 100)
                  : 0;
              newDataArray.push(modifiedData);
            });
            this.datas = newDataArray;
            this.selectedId = this.datas[0].tripId;
            this.loadings = false;
            this.selectedRow = null;
            if (this.selectedRow == null) {
              this.selectedRow = this.datas[0];
            }
            if (this.selectedRowId) {
              const updatedSelectedRow = this.datas.find(
                (item) => item._id === this.selectedRowId
              );
              if (updatedSelectedRow) {
                this.selectedRow = updatedSelectedRow;
              } else {
                this.selectedRowId = null;
              }
            } else if (res.data[0].tripId != null) {
              this.getOnZoneDetailsList(res.data[0].tripId);
            }
          })
          .catch((error) => {
            this.loading = false;
            this.loadings = false;
            console.error("tracking.traccarMonitoringListDetails-error:", error);
            this.$snotify.error("Get get On Route Tracking List failed", "Error!");
          });
      }
    },

    milliseconds(milliseconds) {
      const seconds = Math.floor(milliseconds / 1000);

      if (seconds < 60) {
        return seconds + " seconds";
      } else if (seconds < 3600) {
        const minutes = Math.floor(seconds / 60);
        return minutes + " minutes";
      } else {
        const hours = Math.floor(seconds / 3600);
        return hours + " hours";
      }
    },

    refreshReportList() {
      if (this.refreshId != null) {
        this.getOnZoneDetailsList(this.refreshId);
      }
    },

    getFormattedDate(date) {
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${year}-${month}-${day}`;
    },

    startDate(data) {
      this.clearTripDetails();
      this.loadings = true;

      if (data.length > 0) {
        const eventData = data.split("-");
        const startDates = eventData[2] + "-" + eventData[1] + "-" + eventData[0];
        this.startDateIso = startDates;
        this.getTraccarMonitoring();
      } else {
        this.startDateIso = "";
        this.getTraccarMonitoring();
      }
    },

    clearTripDetails() {
      (this.details = {}), (this.deviceStatus = {});
      (this.refreshId = null), (this.selectedRowId = null);
    },

    onModalClose() {
      this.popupShow = false;
    },

    onRowClick(row) {
      console.log("Selected row:", row);
      this.selectedRowId = row._id;
      this.selectedRow = row;
      this.refreshId = row.tripId;
      if (row.tripId != null) {
        this.getOnZoneDetailsList(row.tripId);
      } else {
        this.popupShow = true;
      }
    },

    getOnZoneDetailsList(zoneId) {
      this.parameters.zoneId = zoneId;
      return dutyTrackingService
        .traccarMonitoringTripDetails(this.parameters)
        .then((res) => {
          res.data[0].routeFileGeoLoc = res.data[0].routeFileGeoLoc.map((x) => {
            var location = res.data[0].locDetails.find(
              (y) => x.lineNumber === y.lineNumber
            );
            if (location) {
              x.status = location.status;
            }
            return {
              coordinate: x.coordinate,
              lineNumber: x.lineNumber,
              status: x.status || false,
            };
          });
          this.details = res.data[0];
          if (res.data[0].startTime && res.data[0].endTime) {
            const startTime = new Date(res.data[0].startTime);
            const endTime = new Date(res.data[0].endTime);
            const timeDifference = endTime - startTime;
            const hours = Math.floor(timeDifference / (1000 * 60 * 60));
            const minutes = Math.floor((timeDifference / (1000 * 60)) % 60);
            const seconds = Math.floor((timeDifference / 1000) % 60);
            this.details["totalTimes"] = `${hours} : ${minutes} : ${seconds} `;
          }
          this.details["scheduleTime"] = res.data[0].scheduleTime
            ? dateFormatter(res.data[0].scheduleTime)
            : "--";
          this.details["startTime"] = res.data[0].startTime
            ? dateFormatter(res.data[0].startTime)
            : "--";
          this.details["endTime"] = res.data[0].endTime
            ? dateFormatter(res.data[0].endTime)
            : "--";
          this.details["tripStatus"] =
            res.data[0].tripStatus.charAt(0).toUpperCase() +
            res.data[0].tripStatus.slice(1);
          this.details["TracarrTimeInZone"] = this.milliseconds(
            res.data[0].TracarrTimeInZone
          );
          this.traccarId = res.data[0].traccarId;
          if (this.LivePositions.length > 0) {
            let filterData = this.LivePositions.filter((e) => {
              return this.traccarId == e.deviceId;
            });
            if (filterData.length) {
              let liveLocation = {};
              liveLocation["lat"] = filterData[0].latitude;
              liveLocation["lng"] = filterData[0].longitude;
              if (liveLocation != "") {
                eventBus.$emit("traccarMonitoringGMapSocket", liveLocation);
              }
            }
          }
          this.liveData = [];
          this.zoneStartTime = res.data[0].zoneStartTime;
          this.zoneEndTime = res.data[0].zoneEndTime;
          if (res.data[0].routeFileGeoLoc != "") {
            eventBus.$emit(
              "traccarMonitoringrouteFileGeoLoc",
              this.details.routeFileGeoLoc
            );
          }
          if (res.data[0].vehicleId != "") {
            eventBus.$emit("traccarMonitoringMapInfoShow", this.details);
          }
        })
        .catch((error) => {
          this.loading = false;
          console.error("tracking.traccarMonitoringTripDetails-error:", error);
          this.$snotify.error("Get get On Duty Staff List failed", "Error!");
        });
    },

    getOnDutyStaffList(cityId) {
      let dutyInfo = [];
      this.surveyorList = [];
      this.driverList = [];
      this.parameters.cityId = cityId;
      return dutyTrackingService
        .dutyMonitoring(this.parameters)
        .then((res) => {
          res.data.response.forEach((element) => {
            if (element.details.geoLocation.length > 0 && element.role == "surveyor") {
              let staff = element;
              staff["location"] = {};
              staff["location"]["lat"] = element.details.geoLocation[1]
                ? element.details.geoLocation[1]
                : "";
              staff["location"]["lng"] = element.details.geoLocation[0];
              staff["lat"] = element.details.geoLocation[1]
                ? element.details.geoLocation[1]
                : "";
              staff["lng"] = element.details.geoLocation[0];
              dutyInfo.push(staff);
            }
          });
          if (res.data.response != "") {
            eventBus.$emit("traccarMonitoringGMap", dutyInfo);
          }
        })
        .catch((error) => {
          this.loading = false;
          console.error("tracking.getOnDutySTaffListFunction-error:", error);
          this.$snotify.error("Get get On Duty Staff List list failed", "Error!");
        });
    },

    getCityList() {
      const params = {};
      this.cityList = [];
      let cities = [];
      this.$cityRepository
        .collectionCitysList(params)
        .then((res) => {
          this.loading = false;
          if (res.data.response.length > 0) {
            res.data.response.forEach((element) => {
              if (element.status === true) {
                cities.push({
                  name:
                    element.cityName.length > 25
                      ? element.cityName.slice(0, 25) + "..."
                      : element.cityName,
                  value: element._id,
                });
              }
            });
            this.cityList = cities;
            this.city = this.$store.state.auth.cityId;
            this.parameters.cityId = this.city.value;
            this.getTraccarMonitoring();
          }
        })
        .catch((error) => {
          this.loading = false;
          console.error("cities.requestFunction-error:", error);
          this.$snotify.error("Get cities list failed", "Error!");
        });
    },

    onLoaded() {
      this.traccarMonitoringZoneTable = this.$refs.traccarMonitoringZoneTable;
    },

    getTraccarUrl() {
      return dutyTrackingService
        .getTraccarToken()
        .then((response) => {
          const token = response.data.token;
          const getDateTime = new Date().getTime();
          let dataTokenGetDateTine = {
            token: token,
            getDateTime: getDateTime,
          };
          this.getTraccarUrlSession(dataTokenGetDateTine);
        })
        .catch((error) => {
          this.loading = false;
          console.error("trackingService-error:", error);
          this.$snotify.error(error.data, "Error!");
        });
    },

    getTraccarUrlSession(data) {
      let dutyInfo = [];
      return dutyTrackingService
        .traccarMonitoringSession(data)
        .then((response) => {
          const socketUrl = "wss://" + config.Traccar_URI + "api/socket";
          this.socket = new WebSocket(socketUrl);
          (this.socket.onopen = () => {
            console.log("WebSocket connection established.");
          }),
            (this.socket.onmessage = (event) => {
              const data = JSON.parse(event.data);
              if (data.devices != null) {
                let device = data.devices;
                let filterDeviceData = device.filter((e) => {
                  return this.traccarId == e.id;
                });
                this.deviceStatus = filterDeviceData[0];
              }
              if (data.positions != null) {
                if (this.LivePositions.length <= 0) {
                  this.LivePositions = data.positions;
                } else if (data.positions != null) {
                  data.positions.forEach((x) => {
                    var index = this.LivePositions.findIndex(
                      (x) => x.deviceId == data.positions[0].deviceId
                    );
                    if (index >= 0) {
                      this.LivePositions[index] = x;
                    } else {
                      this.LivePositions.push(x);
                    }
                  });
                }
              }
              if (this.LivePositions.length > 0) {
                let filterData = this.LivePositions.filter((e) => {
                  return this.traccarId == e.deviceId;
                });
                if (filterData.length) {
                  let liveLocation = {};
                  liveLocation["lat"] = filterData[0].latitude;
                  liveLocation["lng"] = filterData[0].longitude;
                  this.liveLocationData = liveLocation;
                  console.log("liveLocationData", this.liveLocationData);
                }
              }
            });
          this.socket.onerror = (error) => {
            console.error("WebSocket error:", error);
          };
        })
        .catch((error) => {
          this.loading = false;
          console.error("trackingService-error:", error);
          this.$snotify.error(error.data.message, "Error!");
        });
    },

    onCitySelect(city) {
      this.clearTripDetails();
      this.parameters.cityId = city.value;
      this.getTraccarMonitoring();
    },

    dutyTrackingOnInit() {
      if (!this.$store.state.auth.user.cityId) {
        this.getCityList();
        this.getTraccarUrl();
      } else {
        this.cityAdmin = true;
        let cityId = this.$store.state.auth.user.cityId._id;
        this.parameters.cityId = cityId;
        this.getTraccarMonitoring();
        this.getTraccarUrl();
      }
    },
  },

  computed: {
    getPercentage() {
      return this.sliderValue;
    },
  },

  mounted() {
    this.parameters.cityId = this.$store.state.auth.cityId.value;
    eventBus.$on("cityIdChanged", this.onCitySelect);
    this.staffLocationRefresh = setInterval(() => {
      if (this.liveLocationData != "") {
        eventBus.$emit("traccarMonitoringGMapSocket", this.liveLocationData);
      }
    }, 30000);
    this.staffLocationRefreshs = setInterval(() => {
      const today = new Date().toISOString().split("T")[0];
      if (this.startDateIso == today) {
        this.refreshReportList();
        this.getTraccarMonitoring();
      }
    }, 30000);
  },

  created() {
    this.dutyTrackingOnInit();
  },

  beforeDestroy() {
    clearInterval(this.staffLocationRefresh);
    clearInterval(this.staffLocationRefreshs);
    eventBus.$off("cityIdChanged", this.onCitySelect);
    this.socket.close();
  },
};
</script>

<style>
.test-table {
  margin-left: 80px;
}

.subcattable table {
  margin-left: 0px;
}

.subcattable table td,
.subcattable table th {
  border: 1px solid #f4f4f4;
}

.subcattable table tr:nth-of-type(odd) {
  background-color: #f9f9f9;
}

.subcattable table tr:hover {
  background-color: #f2fff9 !important;
}

.edit_del_btn {
  border: 0;
  background-color: transparent;
  color: #0f6940;
}

.subcattable table tr td:last-child {
  width: 200px;
}

.city_dropdown {
  display: flex;
  justify-content: space-between;
  margin: 20px 0px;
}

.city_rel_class {
  width: 150%;
}

.monitor {
  overflow: auto;
  height: 368px;
}

.driver-data .monitor {
  height: 290px !important;
}

.monitor table {
  margin: 0;
  position: relative;
  top: -2px;
}

.monitor table thead {
  position: sticky;
  top: -1px;
}

.table-body-details {
  overflow: auto;
  height: 290px !important;
}

.monitoring_wrp .vue-map-container {
  height: calc(100vh - 243px) !important;
}

.monitoring_wrp .table-responsive {
  height: calc(100vh - 342px);
}

@media (max-width: 1199px) {
  .monitoring_wrp .vue-map-container {
    height: calc(100vh - 260px) !important;
  }
}

@media (max-width: 768px) {
  .monitoring_wrp {
    height: calc(100vh - 235px);
    overflow: auto;
  }

  .monitor table {
    width: 100%;
  }
}

@media (max-width: 767px) {
  .city_dropdown {
    margin: 10px 0px;
    flex-direction: column-reverse;
  }

  .city_rel_class {
    width: 100% !important;
    margin-top: 10px;
  }
}

.trip_details .shedule_date_inner {
  flex: 100%;
  display: flex;
  /* / flex-direction: column; / */
  border-radius: 5px;
  padding: 0px 10px;
  justify-content: space-between;
}

.trip_details .shedule_date_inner h5 {
  color: #000;
  flex: 0 0 50%;
}

.trip_details .shedule_date_inner p {
  font-weight: normal;
  color: #000;
  margin-bottom: 2px;
  text-align: right;
  font-size: 13px;
  font-weight: 700;
}

.trip_details .shedule_date_data {
  margin-top: 0px;
  border-radius: 5px;
}

.trip_details .shedule_date_data label {
  font-size: 18px;
  margin-bottom: 15px;
  width: 100%;
}

/* 
.trip_details {
    overflow: auto;
    height: calc(100vh - 235px);
} */
.dates_left_wrp .dates_left label {
  color: #fff;
  font-size: 18px;
  margin-bottom: 10px;
}

.zone_cart_wrp {
  width: 100%;
  background: #fff;
  margin-bottom: 20px;
  padding: 10px;
}

.zone_cart_wrp h2 {
  color: #000;
}

.traccar_wrp .table-responsive {
  background: #fff;
  margin-top: 15px;
}

.traccar_wrp .table-responsive table {
  margin-left: 0px;
}

.traccar_wrp .VueTables__limit {
  display: none;
}

.dates_left_wrp {
  background: #0f6940;
  padding: 10px 10px 0px 10px;
  border-radius: 5px;
}

.zone_cart_wrp.driver_zone_wrp {
  height: calc(100vh - 575px);
  overflow: auto;
}

.zone_cart_wrp.driver_zone_wrp::-webkit-scrollbar {
  width: 5px;
}

.zone_cart_wrp.driver_zone_wrp::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
.zone_cart_wrp.driver_zone_wrp::-webkit-scrollbar-thumb {
  background: #888;
}

.map-view {
  box-shadow: 2px 2px 2px 2px rgba(0, 0, 0, 0.105);
  border: 5px solid #0f6940;
  border-radius: 5px;
}

.dates_left_wrp p {
  margin-bottom: 0px;
  color: #fff;
  font-weight: 600;
}

.progressContainer {
  height: 22px;
  width: 155px;
  -webkit-appearance: none;
  appearance: none;
  background-color: #eee;
  border-radius: 2px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) inset;
}

.progressReference {
  margin-top: -37px;
  padding: 7px;
  position: relative;
  top: 6px;
}

.dates_left_wrp table tr td {
  font-size: 12px;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  /* Semi-transparent background */
  backdrop-filter: blur(1px);
  /* Apply blur effect to the background content */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  /* Make sure it's on top of other content */
}

.content-centered {
  text-align: center;
}

.traccar_wrp .table-responsive thead {
  z-index: 0;
}

/* .snotifyToast{
   z-index: 3;
} */
.gradientbt:focus {
  color: #fff !important;
  background: #0f6940;
  border-color: #0f6940;
  outline: none;
}

.gradientbt:active:focus,
.gradientbt:focus {
  outline: 0px auto -webkit-focus-ring-color;
  outline-offset: 0px;
}

.route_tracking_trip_details {
  width: 100%;
}

.route_tracking_trip_details .shedule_date_data {
  min-width: auto !important;
}

.media_padding {
  padding-left: 0px;
  padding-right: 0px;
}

@media (max-width: 767px) {
  .media_padding {
    padding-left: 15px;
    padding-right: 15px;
  }

  .route_tracking_trip_details {
    margin-top: 20px;
  }
}

.monitoring_wrp .table-bordered {
  min-width: auto !important;
}

.selected-row {
  background-color: #b7d5c7;
}

.selected-row td {
  color: #000;
  font-weight: 700;
}

.zoneDetails {
  overflow-y: auto;
  height: calc(100vh - 324px);
}

.zoneDetails::-webkit-scrollbar {
  width: 5px;
  height: 0px;
}

.zoneDetails::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.zoneDetails::-webkit-scrollbar-thumb {
  background: #888;
}

.new_dates_left {
  padding-bottom: 10px;
}

.progressContainer::-webkit-progress-value {
  background-color: #00bd08;
}

.progressContainer::-webkit-progress-bar {
  background-color: #9e9a9a;
}

.monitoring_wrp .collection_divisions_table table tr:nth-child(1) th,
.monitoring_wrp .collection_divisions_table table tr:nth-child(1) td {
  width: 45%;
}

.monitoring_wrp .collection_divisions_table table tr:nth-child(1) {
  position: sticky;
  top: 0px;
  left: 0px;
  z-index: 1;
}

.monitoring_wrp .collection_divisions_table table tr th {
  text-align: center;
}

.monitoring_wrp .details-card {
  padding: 0px 5px;
}

.zoneDetails table {
  margin: 0px;
  width: 100%;
}

.zoneDetails table tr {
  cursor: pointer;
}

.monitoring_wrp .collection_divisions_table table tr td,
.monitoring_wrp .collection_divisions_table table tr th {
  border: 2px solid #0f6940;
}

@media (max-width: 1325px) {
  .zoneDetails {
    height: calc(100vh - 362px);
  }

  .route_tracking_trip_details .shedule_date_data {
    height: calc(100vh - 275px);
    overflow: auto;
  }
}

@media (max-width: 767px) {
  .dates_left_wrp {
    margin-bottom: 20px;
  }
}

.overlay_inner .popup_modal h4 {
  background-color: #ffffff;
  text-align: center;
  color: red;
  border: none;
}

.overlay_inner .popup_modal p {
  text-align: center;
  padding-left: 10px;
  font-size: large;
}

.form-actions.dismiss {
  text-align: center;
  font-size: large;
  padding: 10px;
  color: #007bff;
  cursor: pointer;
  text-decoration: underline;
  border: none;
}

button.popup-dismiss {
  background: red;
  border-radius: 25px;
  color: white;
  width: 125px;
  border: white;
}

.popup-titles {
  text-align: center;
  font-size: 24px;
  line-height: 36px;
  color: #000;
  font-weight: 700;
}

.rounded {
  border-radius: 30px;
}

.iconMina {
  padding: 40px;
  background-color: red;
  display: flex;
  border-top-left-radius: 30px;
  border-top-right-radius: 30px;
  justify-content: center;
  align-items: center;
  color: white;
}

.row.form-modal.popup_modal.rounded {
  width: 23%;
  height: 283px;
}

.mark {
  margin-left: 75%;
}

.houses_wrp {
  display: flex;
  flex-wrap: wrap;
}

.house_number_wrp .form-group {
  margin-bottom: 0;
}

.flex.house_number_wrp {
  display: flex;
  align-items: baseline;
  flex: 0 0 15%;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// traccarMonitoringBeta.vue?837f446a